var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-navigation"},_vm._l((_vm.navigationList),function(item,index){return _c('div',{key:index,class:[
      'navigation',
      { 'navigation-active': index === _vm.navigationIndex } ],on:{"click":function($event){return _vm.skip(item.routerPath)}}},[_c('img',{attrs:{"src":_vm.navigationIndex === index ? item.imgurlActive : item.imgurl,"alt":"图片"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741f1a1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mycom/settingsNavigation.vue
// module id = null
// module chunks = 